/** Bakım modunda portalı kullanmaya devam edebilecek roller */
export function isMaintenanceBypassRole(role) {
  return role === "ROOT_ADMIN";
}

function roleFromStorageUser() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw || !raw.startsWith("{")) return null;
    const user = JSON.parse(raw);
    return user && user.role ? user.role : null;
  } catch (e) {
    return null;
  }
}

function roleFromToken() {
  try {
    const token = localStorage.getItem("token");
    if (!token || token.indexOf(".") < 0) return null;
    const part = token.split(".")[1];
    if (!part) return null;
    const json = atob(part.replace(/-/g, "+").replace(/_/g, "/"));
    const payload = JSON.parse(json);
    return payload && payload.role ? payload.role : null;
  } catch (e) {
    return null;
  }
}

/** Redux me, localStorage user veya JWT — ROOT_ADMIN ise bakım bypass */
export function canBypassMaintenance(me) {
  if (isMaintenanceBypassRole(me && me.role)) return true;
  if (isMaintenanceBypassRole(roleFromStorageUser())) return true;
  if (isMaintenanceBypassRole(roleFromToken())) return true;
  return false;
}

export function isMaintenanceModeEnabled() {
  const brand = (window.config && window.config.appBrand) || {};
  return !!brand.maintenanceMode;
}
